<template>
<div class="table-responsive">    
<table class="table v-middle border">
    <thead>
        <tr class="">
            <th class="border-top-0">Etkinlikler</th>
            <th class="border-top-0">Etkinlik Türü</th>
            <th class="border-top-0">Etkinlik Alt Türü</th>
            <th class="border-top-0">Salon</th>
           
            <th class="border-top-0">Kurum İçi/Kurum Dışı</th>
            <th class="border-top-0">Toplam Fon</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                <div class="d-flex align-items-center">
                    <div class="mr-2"><vs-avatar color="primary" text="Erimary" /></div>
                    <div class="">
                        <h5 class="m-b-0">Etkinlik 1</h5>
                    </div>
                </div>
            </td>
            <td>Sanatsal</td>
            <td>Fonetik Sanatlar</td>
            <td>
                <label class="label label-danger">Salon1</label>
            </td>
           
            <td>Kurum İçi</td>
            <td>
                <h5 class="m-b-0">2850.06 ₺</h5>
            </td>
        </tr>
        <tr>
            <td>
                <div class="d-flex align-items-center">
                    <div class="mr-2"><vs-avatar color="danger" text="Mrimary" /></div>
                    <div class="">
                        <h5 class="m-b-0">Etkinlik 2</h5>
                    </div>
                </div>
            </td>
            <td>Toplantı</td>
            <td>Anma</td>
            <td>
                <label class="label label-info">Salon2</label>
            </td>
           
            <td>Kurum Dışı</td>
            <td>
                <h5 class="m-b-0">2850.06 ₺</h5>
            </td>
        </tr>
        <tr>
            <td>
                <div class="d-flex align-items-center">
                    <div class="mr-2"><vs-avatar color="warning" text="Primary" /></div>
                    <div class="">
                        <h5 class="m-b-0">Etkinlik 3</h5>
                    </div>
                </div>
            </td>
            <td>Eğitim</td>
            <td>Sürekli Eğitim</td>
            <td>
                <label class="label label-success">Salon3</label>
            </td>
          
            <td>Kurum Dışı</td>
            <td>
                <h5 class="m-b-0">2850.06 ₺</h5>
            </td>
        </tr>
        <tr>
            <td>
                <div class="d-flex align-items-center">
                    <div class="mr-2"><vs-avatar color="success" text="Arimary" /></div>
                    <div class="">
                        <h5 class="m-b-0">Etkinlik 4</h5>
                    </div>
                </div>
            </td>
            <td>Diğer</td>
            <td>Yemek PLanı</td>
            <td>
                <label class="label label-purple">Salon4</label>
            </td>
            
            <td>Kurum İçi</td>
            <td>
                <h5 class="m-b-0">2850.06 ₺</h5>
            </td>
        </tr>
    </tbody>
</table>
</div>
</template>
<script>
export default {
    name: "TopProducts"
}
</script>